module.exports = __webpack_public_path__ + "img/section3_img.4c6f420e.svg";